import type { Stylable } from '@core/utils/types'
import { cn } from 'cn'
import type { HTMLAttributes } from 'react'

export interface SkeletonProps
  extends Stylable,
    HTMLAttributes<HTMLDivElement> {
  fade?: boolean
}

export function Skeleton({ className, fade, ...props }: SkeletonProps) {
  return (
    <div
      className={cn(
        'animate-shimmer rounded-md bg-[length:200%_100%] bg-[linear-gradient(90deg,var(--color-muted)_0%,var(--color-border)_40%,var(--color-muted)_80%)]',
        fade && 'opacity-40',
        className
      )}
      {...props}
    />
  )
}
